// Components
import { Tooltip } from '../Tooltip';

// Types
import { INormalizedTeamForm } from '../../../../types';
import { SMPStandingsWinIcon } from '../../atoms/icons/SMPStandingsWinIcon';
import { SMPStandingsLossIcon } from '../../atoms/icons/SMPStandingsLossIcon';
import { SMPStandingsWinOverTimeIcon } from '../../atoms/icons/SMPStandingsWinOverTimeIcon';
import { SMPStandingsLossOverTimeIcon } from '../../atoms/icons/SMPStandingsLossOvertimeIcon';

export interface IFormIconProps {
  form: INormalizedTeamForm;
}

export const StandingsFormIcon = ({ form }: IFormIconProps): JSX.Element => {
  const { outcome, startTime, matchSummary } = form;
  return (
    <Tooltip text={startTime} overlineText={matchSummary} standingsForm>
      {
        {
          win: <SMPStandingsWinIcon width='4' height='4' />,
          loss: <SMPStandingsLossIcon width='4' height='4' />,
          win_overtime: <SMPStandingsWinOverTimeIcon width='4' height='4' />,
          loss_overtime: <SMPStandingsLossOverTimeIcon width='4' height='4' />,
          win_after_penalty: <SMPStandingsWinOverTimeIcon width='4' height='4' />,
          loss_after_penalty: <SMPStandingsLossOverTimeIcon width='4' height='4' />,
        }[outcome]
      }
    </Tooltip>
  );
};
